import { type ComponentProps } from 'react'
import { type VariantProps } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'
import { itemDescriptionVariants } from '../styles'

interface ItemDescriptionProps extends ComponentProps<'span'>, VariantProps<typeof itemDescriptionVariants> {
  className?: string
}

/**
 * The sentence under the title, clamped to two lines. `tone="danger"` is the same slot turned
 * into the error, so a problem replaces the explanation in place and the row keeps its height;
 * it is announced, since a row's error is news.
 */
function ItemDescription({ className, tone, children, ...props }: ItemDescriptionProps) {
  const isError = tone === 'danger'
  return (
    <span
      data-slot="item-description"
      role={isError ? 'alert' : undefined}
      className={twMerge(
        itemDescriptionVariants({ tone }),
        'line-clamp-2 break-words',
        'group-data-[disabled]/item:text-foreground-disabled',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export { ItemDescription }
export type { ItemDescriptionProps }
